/* eslint-disable no-console */
import {useEffect} from "react";
import {TabBody, TabColumn} from "../../tab-content";
import {ManagedTab} from "../../managed-tabs";
import {CommonOrgComponentProps, CommonOrgComponentLoader} from "../../pbc";
import "./CommonOrgComponentTab.scss";

export const CommonOrgComponentTab: ManagedTab<CommonOrgComponentProps> = ({
  component,
  commonOrgId
}) => {
  useEffect(() => {
    console.info(`Rendering CommonOrgComponentTab: ${component.element}`);
    return () => {
      console.info(`Cleanup CommonOrgComponentTab: ${component.element}`);
    };
  }, [component.element]);

  return (
    <TabBody
      name={component.element}
      className={`common-org-component-tab-body ${
        (component.contained ?? true)
          ? "common-org-component-tab-body--contained"
          : "common-org-component-tab-body--uncontained"
      }`}>
      <TabColumn name={"main"}>
        <CommonOrgComponentLoader
          component={component}
          commonOrgId={commonOrgId}
        />
      </TabColumn>
    </TabBody>
  );
};
